import { customInstance } from "../../custom-instance";
export const get = () => {
    const approvalDocumentControllerGetApprovalDocuments = (params) => {
        return customInstance({
            url: `/approval-document`,
            method: "GET",
            params,
        });
    };
    const approvalDocumentControllerPostApprovalDocument = (createApprovalDocumentDto) => {
        return customInstance({
            url: `/approval-document`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: createApprovalDocumentDto,
        });
    };
    const approvalDocumentControllerGetProcessList = (params) => {
        return customInstance({
            url: `/approval-document/process/list`,
            method: "GET",
            params,
        });
    };
    const approvalDocumentControllerGetProcess = (id) => {
        return customInstance({
            url: `/approval-document/${id}/process`,
            method: "GET",
        });
    };
    const approvalDocumentControllerGetProductsForInbound = (id) => {
        return customInstance({
            url: `/approval-document/${id}/products-for-inbound`,
            method: "GET",
        });
    };
    const approvalDocumentControllerGetApprovalDocument = (id) => {
        return customInstance({
            url: `/approval-document/${id}`,
            method: "GET",
        });
    };
    const approvalDocumentControllerPatchApprovalDocument = (id, updateApprovalDocumentDto) => {
        return customInstance({
            url: `/approval-document/${id}`,
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            data: updateApprovalDocumentDto,
        });
    };
    const approvalDocumentControllerDeleteApprovalDocument = (id) => {
        return customInstance({
            url: `/approval-document/${id}`,
            method: "DELETE",
        });
    };
    const approvalDocumentControllerPatchSubmit = (id) => {
        return customInstance({
            url: `/approval-document/${id}/submit`,
            method: "PATCH",
        });
    };
    const approvalDocumentControllerPatchCancelSubmission = (id) => {
        return customInstance({
            url: `/approval-document/${id}/cancel`,
            method: "PATCH",
        });
    };
    return {
        approvalDocumentControllerGetApprovalDocuments,
        approvalDocumentControllerPostApprovalDocument,
        approvalDocumentControllerGetProcessList,
        approvalDocumentControllerGetProcess,
        approvalDocumentControllerGetProductsForInbound,
        approvalDocumentControllerGetApprovalDocument,
        approvalDocumentControllerPatchApprovalDocument,
        approvalDocumentControllerDeleteApprovalDocument,
        approvalDocumentControllerPatchSubmit,
        approvalDocumentControllerPatchCancelSubmission,
    };
};
